export const ALL_ZONE_POST = "zone/list";
export const ZONE_DETAILS_GET = "zone/detail";
export const DELETE_ZONE_POST = "zone/delete";
export const ADD_ZONE_POST = "zone/add";
export const UPDATE_ZONE_POST = "zone/update";
export const EDIT_ZONE_POST = "zone/edit";
export const CREATE_ZONE_POST = "zone/create";